import React from 'react';
import { Box, Typography } from '@mui/material';

function Hero() {
    return (
        <Box
            sx={{
                textAlign: 'center',
                py: 8,
                px: 4,
                backgroundImage: 'url(/img/csn-hero.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#fff',
            }}
        >
            <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                AWS Cloud Bootcamp
            </Typography>
            <Typography variant="h6" color="#e0e0e0">
                Starting June 7, 2025 — Join our 12-week intensive cloud journey and boost your career.
            </Typography>
        </Box>
    );
}

export default Hero;
